module.exports = __webpack_public_path__ + "static/media/top-icon-g.1534c7b6.svg";